import { ParentState } from "@hopper-b2b/checkout";
import type { State } from "xstate";
import type { ParentContextWithRewardsPayment } from "./types";

type CommonStateType = State<ParentContextWithRewardsPayment>;
type CommonStateWithoutValue = Pick<CommonStateType, "context">;

export const getState = (state: CommonStateWithoutValue) => state;

export const getIsRewardsSelected = (state: CommonStateWithoutValue) =>
  state.context[ParentState.awardsPayment].rewardsSelected;

export const getRewardsAmountToApply = (state: CommonStateWithoutValue) => {
  return state.context[ParentState.awardsPayment].rewardsAmountToApply;
};

export const getRewardsAmountToApplyInCash = (
  state: CommonStateWithoutValue
) => {
  return state.context[ParentState.awardsPayment].rewardsAmountToPayInCash;
};

export const getRewardsBalance = (state: CommonStateWithoutValue) => {
  return state.context[ParentState.awardsPayment].rewardsBalance;
};

export const getRewardsBalanceInCash = (state: CommonStateWithoutValue) => {
  return state.context[ParentState.awardsPayment].rewardsBalanceInCash;
};
